import React from "react"; 
import { Table } from "react-bootstrap";
import InputField from "../../components/InputField";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ReplenishmentRequestDetailsTable = ({
  headers = [],
  data = [],
  handleQuantityChange,
  updateQuantity,
  toggleIsEditing,
  handleKeyDown
}) => {
  console.log("Rendering Table with Data:", data);

  return (
    <>
      {data.length === 0 ? (
        <div className="text-center py-4">
          <h5>No matching SKU found</h5>
        </div>
      ) : (
        <form onKeyDown={handleKeyDown}>
         <Table responsive bordered width="100%" cellSpacing={0}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "left" }}>{item.sku_name}</td>
                <td>{item.sku_id}</td>
                <td>
                  <InputField
                    type="number"
                    value={item.editedQuantity || ""}
                    onChange={(e) =>
                      handleQuantityChange(item.id, e.target.value)
                    }
                    disabled={item.status !== "awaiting_approval" || !item.isEditing}
                    icon={
                      item.isEditing ? (
                        <CheckCircleIcon
                          sx={{ fontSize: 18, cursor: "pointer" }}
                          onClick={() => {
                            toggleIsEditing(item.id);
                            updateQuantity(item.id, item.editedQuantity);
                          }}
                        />
                      ) : (
                        <EditIcon
                          sx={{ fontSize: 18, cursor: "pointer" }}
                          onClick={() => toggleIsEditing(item.id)}
                        />
                      )
                    }
                  />
                </td>
                <td>{item.covered_inventory}</td>
                <td>{item.on_hand_inventory}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        </form>
      )}
    </>
  );
};

export default React.memo(ReplenishmentRequestDetailsTable);
